var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodeWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;strokeMiterlimit:10;strokeWidth:1.25px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "node") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "techSkills_Logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "node.js"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.08,17.38,30.82,6a1.33,1.33,0,0,1,1.36,0l19.73,11.4a1.34,1.34,0,0,1,.68,1.18V41a1.36,1.36,0,0,1-.69,1.19l-19.74,11a1.35,1.35,0,0,1-1.32,0l-19.74-11A1.36,1.36,0,0,1,10.41,41V18.56A1.36,1.36,0,0,1,11.08,17.38Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.82,
    y1: 16.96,
    x2: 31.94,
    y2: 53.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.84,
    y1: 41.95,
    x2: 18.48,
    y2: 29.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.94,
    y1: 5.85,
    x2: 52.59,
    y2: 40.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.91,
    y1: 17.36,
    x2: 45.53,
    y2: 28.92
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeWhite);
export default __webpack_public_path__ + "static/media/node_white.606a282f12ae01ff23ce0d11161b8003.svg";
export { ForwardRef as ReactComponent };